import React from 'react';
import { Grid, Box } from '@mui/material';
import PageContainer from 'src/components/container/PageContainer';


import ProductGrid from './components/ProductGrid';
import '../../assets/style.css'



const Products = () => {
  return (
    <PageContainer title="Offers | Earnpati" description="these are EarnPati Affiliate Offers">
      <Box>
        <Grid container spacing={3}>
          
          
          
          <Grid item xs={12}>
          <h2>Available Offers</h2>
            <ProductGrid />
          </Grid>
          <Grid item xs={12}>
         
          </Grid>
          
        </Grid>
      </Box>
    </PageContainer>
  );
};

export default Products;
